import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { SelfCheckinSettingsFragment } from './common';

export interface UpdateSelfCheckinSettingsResult {
  updateSelfCheckinSettings: {
    event: {
      id: string;
      allowUserCheckin: boolean;
      sendUserCheckinEmail: boolean;
      sendUserCheckinSlack: boolean;
      selfCheckinSchedule: {
        unit: string;
        quantity: number;
        beforeEventBegins: boolean;
      } | null;
      isSelfCheckinEditable: boolean;
    };
    ok: boolean;
  };
}

export interface UpdateSelfCheckinSettingsVariables {
  input: {
    eventId: number;
    allowUserCheckin: boolean;
    sendUserCheckinEmail?: boolean;
    sendUserCheckinSlack?: boolean;
    sendUserCheckinSchedule?: {
      unit: string;
      quantity: number;
      beforeEventBegins: boolean;
    } | null;
  };
}

const UpdateSelfCheckinSettingsMutation = gql`
  mutation UpdateSelfCheckinSettings($input: UpdateSelfCheckinSettingsInputType!) {
    updateSelfCheckinSettings(input: $input) {
      ok
      event {
        id
        ...SelfCheckinSettingsFragment
      }
    }
  }
  ${SelfCheckinSettingsFragment}
`;

export const updateSelfCheckinSettings = (
  variables: UpdateSelfCheckinSettingsVariables
): Promise<UpdateSelfCheckinSettingsResult> => {
  return gqlClient.request<UpdateSelfCheckinSettingsResult>(
    UpdateSelfCheckinSettingsMutation,
    variables
  );
};
